// Extracts the applied-for job title (Stelle) from a questionnaire's matrix /
// combobox answer so the results overview can show what a candidate applied
// for. The question comes from a user-managed default-question template, so
// its wording varies between questionnaires — detection is keyword-based with
// a single-candidate fallback.

const JOB_QUESTION_PATTERN = /stelle|position|arbeitsmodell|bewirbst|interessierst|job/i;

// Tags are removed without a separator: the editor's rich text can split a
// word with inline markup (e.g. "<em>Pos</em>ition").
const stripHtml = (value) => String(value || '').replace(/<[^>]*>/g, '');

export const findJobQuestion = (questions) => {
    const candidates = (Array.isArray(questions) ? questions : []).filter(
        (q) => q && (q.type === 'matrix' || q.type === 'combobox')
    );
    if (candidates.length === 0) return null;

    // Keyword match only — better silent than wrong: a lone matrix/combobox
    // question without job keywords is usually something else entirely
    // (e.g. language skills), so there is no single-candidate fallback.
    return candidates.find((q) => JOB_QUESTION_PATTERN.test(stripHtml(q.text))) || null;
};

export const getJobTitleEntries = (questions, answers = {}) => {
    const question = findJobQuestion(questions);
    if (!question) return [];

    const rows = answers?.[question.id];
    if (!Array.isArray(rows)) return [];

    return rows
        .filter((row) => row && typeof row === 'object' && String(row.value || '').trim())
        .map((row) => {
            const label = String(row.label || '').trim();
            const value = String(row.value || '').trim();
            return label ? `${label} · ${value}` : value;
        });
};
